<template>
  <div>  
    <!-- Modal -->
    <b-modal
      id="scout-modal"
      size="lg"
      ref="scoutConfirmation"
      centered
    >
    <template #modal-header>
      <h4 class="modal-title">スカウト対象へ追加するには、以下を設定してください。</h4>
    </template>
      <div class="modal-content-wrapper">
        <!-- Step 1 -->
        <div class="step-section mb-4">
          <div class="d-flex align-items-center mb-2">
            <span class="step-badge mr-4">
              Step1
            </span>
            <h6 class="mb-0 font-weight-bold">スカウトする求人</h6>
          </div>
          <div class="d-flex" style="gap: 20px;margin-left: 70px;">
              <span :class="checkboxTextClass">{{  checkboxText }}</span>
              <div class="d-flex align-items-center">
                <input 
                  type="checkbox" 
                  id="scout-job" 
                  class="checkbox-input mr-2"
                  v-model="scoutWithoutJob"
                  :disabled="isCheckboxDisabled"
                >
                <label 
                  for="scout-job" 
                  class="mb-0"
                >
                  求人を添付せずにスカウトする
                </label>
              </div>
            </div>
        </div>

        <!-- Step 2 -->
        <div class="step-section mb-4">
          <div class="d-flex align-items-center mb-2">
            <span class="step-badge mr-4">
              Step2
            </span>
            <h6 class="mb-0 font-weight-bold">スカウト種別（必須）</h6>
          </div>
          <div class="" style="margin-left: 70px;">
            <div class="radio-options">
              <div 
                class="form-check mb-2" 
                v-for="option in scoutOptions" 
                :key="option.value"
              >
                <input 
                  class="form-check-input custom-radio" 
                  type="radio" 
                  name="scoutScope" 
                  :id="option.value"
                  :value="option.value"
                  v-model="selectedScoutType"
                >
                <label class="form-check-label mt-1" :for="option.value">
                  {{ option.label }}
                </label>
              </div>
            </div>
          </div>

          <p class="text-muted small" >
            ※通知のみは、求人添付および登録者からの回答受付はできません
          </p>
        </div>
      </div>
      <template #modal-footer>
          <div class="d-flex justify-content-end w-100">
            <b-button 
              variant="secondary" 
              class="mr-3 px-4 action-btn"
              @click="$bvModal.hide('scout-modal')"
            >
              キャンセル
            </b-button>
            <b-button 
              variant="danger" 
              class="px-4 action-btn"
              :disabled="!isFormValid"
              @click="startScouting"
            >
               スカウト対象に追加
            </b-button>
          </div>
        </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'ScoutModal',
  props: {
    applicantJD: {
      type: Object,
      default: null
    },
    fromJd: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedScoutType: '応募案内',
      scoutWithoutJob: false,
      scoutOptions: [
        { value: '応募案内', label: '応募案内' },
        { value: 'カジュアル面談', label: 'カジュアル面談' },
        { value: '面接案内', label: '面接案内' },
        { value: '通知のみ', label: '通知のみ' }
      ]
    }
  },
  computed: {
    isCheckboxDisabled() {
      return this.hasApplicantJD || this.fromJd;
    },
    hasApplicantJD() {
      return this.applicantJD && Object.keys(this.applicantJD).length > 0;
    },
    isFormValid() {
      if (this.hasApplicantJD || this.fromJd) {
        return this.selectedScoutType !== '';
      } else {
        return this.scoutWithoutJob && this.selectedScoutType !== '';
      }
    },
    checkboxText() {
      if (this.hasApplicantJD || this.fromJd) {
        return '選択済';
      } else if(!this.scoutWithoutJob) {
        return '※選択してください';
      } else {
        return '選択してください'
      }
    },  
    checkboxTextClass() {
      if (this.hasApplicantJD || this.fromJd) {
        return 'text-teal-underline';
      } else if (!this.scoutWithoutJob) {
        return 'text-danger-underline';
      } else {
        return 'text-dark-underline';
      }
    }
  },
  methods: {
    show() {
      this.$refs.scoutConfirmation.show();
    },
    hide() {
      this.$refs.scoutConfirmation.hide();
    },
    startScouting() {
      if (!this.isFormValid) {
        if (!this.hasApplicantJD && !this.scoutWithoutJob) {
          alert('求人を作成せずにスカウトするにチェックを入れてください。');
          return;
        }
        if (!this.selectedScoutType) {
          alert('スカウト範囲を選択してください。');
          return;
        }
      }
      
              // Call the parent's scoutApplicant method with scout type
        this.$emit('scout-confirmed', this.selectedScoutType);
      
      // Close the modal
      this.$bvModal.hide('scout-modal');
      
      // Reset form
      this.selectedScoutType = '応募案内';
      this.scoutWithoutJob = false;
    }
  }
}
</script>

<style scoped>
.action-btn {
  width: 167px;
  height: 47px;
  border-radius: 30px !important;
  font-size: 12px;
  font-weight: bold;
}
.text-muted.small {
  font-size: 10px;
  margin-right: 120px;
  float: right;
}
.checkbox-input {
  width: 20px;
  height: 20px;
}

.step-badge {
  font-size: 18px;
  font-weight: bold;
  color: #006C6B;
  font-weight: bold;
}

.step-section {
  /* border-left: 2px solid #e9ecef; */
  padding-left: 1rem;
  margin-left: 25px;
}

.step-section:last-child {
  border-left: none;
}

.radio-options {
  display: flex;
  justify-content: flex-start;
  gap: 20px;
}

.font-10 {
  font-size: 10px;
}

.radio-options .form-check-label {
  font-size: 14px;
  cursor: pointer;
}

.modal-content-wrapper {
  padding: 1rem;
}

::v-deep .modal-body {
  padding-bottom: 0px;
}

::v-deep .modal-footer {
  border-top: none;
}

/* Custom modal title styling */
::v-deep .modal-title {
  font-size: 18px;
  font-weight: bold;
}

::v-deep .modal-header {
  border-bottom: none;
}

/* Custom radio button styling */
.form-check-input:checked {
  background-color: #28a745;
  border-color: #28a745;
}

/* Custom HTML radio button styling */
.custom-radio {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  border: 2px solid #ccc;
  border-radius: 50%;
  outline: none;
  cursor: pointer;
  position: relative;
  background-color: white;
  vertical-align: middle;
  flex-shrink: 0;
}

.form-check {
  display: flex;
  align-items: center;
}

.form-check-label {
  margin-bottom: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.custom-radio:checked {
  border-color: #006C6B;
  background-color: white;
}

.custom-radio:checked::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #006C6B;
}

.custom-radio:focus {
  border-color: #006C6B;
  box-shadow: 0 0 0 2px rgba(0, 108, 107, 0.25);
}

.custom-radio:hover {
  border-color: #006C6B;
}

/* Conditional text styling */
.text-teal-underline {
  color: #006C6B !important;
  text-decoration: underline;
}

.text-danger-underline {
  color: #dc3545 !important;
  text-decoration: underline;
}

.text-dark-underline {
  color: #333 !important;
  text-decoration: underline;
}

/* Disabled checkbox styling */
.checkbox-input:disabled {
  background-color: #3c3c3c;
  border-color: #3c3c3c;
  cursor: not-allowed;
  opacity: 1;
}

.checkbox-input:disabled + label {
  cursor: not-allowed;
  color: inherit;
  opacity: 1;
}
</style> 